import React, { FC, ForwardedRef, HTMLAttributes } from 'react'

import clsx from 'clsx'

export interface HeadingProps extends HTMLAttributes<HTMLParagraphElement> {
  theme?: 'card' | 'section' | 'page'
  as?:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'i'
    | 'u'
    | 'abbr'
    | 'cite'
    | 'del'
    | 'em'
    | 'ins'
    | 'kbd'
    | 'mark'
    | 's'
    | 'samp'
    | 'sub'
    | 'sup'
}

export const HeadingStyle = {
  card: 'font-medium text-lg',
  page: 'font-bold text-2xl leading-tight',
  section: 'font-bold text-xl leading-snug'
}

// Please do not use types off of a default export module or else Storybook Docs will suffer.
// see: https://github.com/storybookjs/storybook/issues/9556
/**
 * Heading - Basic text element implementing `body` text styles
 * https://www.figma.com/file/JoOzcZfzFEfLf7LvLShaINKI/Component-Library?node-id=191%3A41
 */
export const Heading: FC<HeadingProps> = React.forwardRef(
  (
    { as = 'h3', children, className, theme = 'card', ...props }: HeadingProps,
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return React.createElement(
      as,
      {
        ...props,
        className: clsx(className, 'text-text-default', HeadingStyle[theme]),
        ref
      },
      children
    )
  }
)
